"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguagesTypeId = exports.Chinese = exports.Portuguese = exports.Korean = exports.Japanese = exports.Italian = exports.French = exports.Spanish = exports.English = exports.German = exports.VideoType = exports.TemplateType = exports.LogoType = exports.DocumentType = exports.AudioType = exports.ImageType = void 0;
exports.ImageType = "Image";
exports.AudioType = "Audio";
exports.DocumentType = "Document";
exports.LogoType = "Logo";
exports.TemplateType = "Template";
exports.VideoType = "Video";
exports.German = "German";
exports.English = "English";
exports.Spanish = "Spanish";
exports.French = "French";
exports.Italian = "Italian";
exports.Japanese = "Japanese";
exports.Korean = "Korean";
exports.Portuguese = "Portuguese";
exports.Chinese = "Chinese";
exports.LanguagesTypeId = "languages";
//# sourceMappingURL=constants.js.map